// extracted by mini-css-extract-plugin
export default {"divider":"GroupedTaskNavigation_divider__Gtnw2"};